module.exports = __webpack_public_path__ + "static/media/classics-10217.c1254dd9.png";